export default __webpack_public_path__ + "static/media/ill-no-class.03cf88f7.svg";